import { render } from "./ClassRoomStudentList.vue?vue&type=template&id=5ec445b4&scoped=true&ts=true"
import script from "./ClassRoomStudentList.vue?vue&type=script&lang=ts"
export * from "./ClassRoomStudentList.vue?vue&type=script&lang=ts"

import "./ClassRoomStudentList.vue?vue&type=style&index=0&id=5ec445b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec445b4"]])

export default __exports__